__turbopack_context__.v({
  "container": "CoverHighlight-module__TE-YAa__container",
  "fadeInItems": "CoverHighlight-module__TE-YAa__fadeInItems",
  "info": "CoverHighlight-module__TE-YAa__info",
  "infoWrapper": "CoverHighlight-module__TE-YAa__infoWrapper",
  "link": "CoverHighlight-module__TE-YAa__link",
  "spacing--lg": "CoverHighlight-module__TE-YAa__spacing--lg",
  "spacing--md": "CoverHighlight-module__TE-YAa__spacing--md",
  "spacing--sm": "CoverHighlight-module__TE-YAa__spacing--sm",
  "spacing--xl": "CoverHighlight-module__TE-YAa__spacing--xl",
  "spacing--xs": "CoverHighlight-module__TE-YAa__spacing--xs",
  "spacing--xxl": "CoverHighlight-module__TE-YAa__spacing--xxl",
  "spacing--xxs": "CoverHighlight-module__TE-YAa__spacing--xxs",
  "spacing--xxxl": "CoverHighlight-module__TE-YAa__spacing--xxxl",
  "spacing--xxxs": "CoverHighlight-module__TE-YAa__spacing--xxxs",
  "tag": "CoverHighlight-module__TE-YAa__tag",
  "tags": "CoverHighlight-module__TE-YAa__tags",
  "title": "CoverHighlight-module__TE-YAa__title",
});
